import { create } from 'zustand';
import type { Me } from '@/api/auth';

type SessionState = {
  user: Me | null;
  status: 'unknown' | 'authenticated' | 'anonymous';
  setUser: (u: Me | null) => void;
};

export const useSession = create<SessionState>((set) => ({
  user: null,
  status: 'unknown',
  setUser: (u) => set({ user: u, status: u ? 'authenticated' : 'anonymous' }),
}));
